// 该store获取所有可以通过运营配置的数据
import api from '@/api'
import { report } from '@/report/index.js'
import {
  Cat1, Cat2, Cat3,
  homeListType, extSearchpage
} from '@/common/const.js'

export default {
  namespaced: true,
  state: () => ({
    home: {
      [Cat1]: 1,
      [Cat2]: 0,
      [Cat3]: 0,
      keyword: '',
      page: 1,
      size: 20, // 该值设置无效，获取接口时会根据类型重置
      sort: 1,
    },

    listType: homeListType.search,

    asideArr: [],

    homeRes: {
      list: [],
      count: 0
    },

    numberCol: 2,

    collectIdList: [], // 个人所有收藏id列表
  }),
  mutations: {
    vuexSetAsideList (state, arr) {
      state.asideArr = Object.freeze(arr)
    },

    /** 传入的对象，如何key值和目标key值一样，要确保值有效 */
    vuexChangeHomeParames (state, obj) {
      Object.keys(obj).forEach(key => {
        // state.home的值可能为0，hasOwnProperty提示错误
        if (key in state.home) {
          state.home[key] = obj[key]
        }
      })
    },

    vuexChangeHomeRes (state, obj) {
      state.homeRes.list = state.homeRes.list.concat(obj.list || [])
      state.homeRes.count = obj.count || 0
    },

    vuexResetHomeRes (state) {
      state.homeRes.list = []
      state.homeRes.count = 0
    },

    vuexChangeHomeNumberCol (state, numberCol) {
      state.numberCol = numberCol
    },

    vuexChangeHomeListType (state, type) {
      state.listType = type
    },

    vuexPushCollectIdList (state, idOrList) {
      if (Array.isArray(idOrList)) {
        state.collectIdList = idOrList
        return
      }
      state.collectIdList.push(idOrList)
    },

    removeCollectId (state, id) {
      const index = state.collectIdList.lastIndexOf(id)
      state.collectIdList.splice(index, 1)
    },

    vuexResetHomePage (state) {
      state.home.page = 1
    }
  },
  actions: {
    vuexSetAsideList ({ commit }, arr) {
      commit('vuexSetAsideList', arr)

      // 初始化home的搜索参数为第一个
      commit('vuexChangeHomeParames', arr[0])
    },

    vuexChangeActiveIndex ({ dispatch, commit, state }, index) {
      commit('vuexChangeActiveIndex', index, { root: true })
      // 定位选中的id在分类的位置，并恢复 page：1, keyword: ''
      dispatch('vuexChangeHomeParames', { ...state.asideArr[index], keyword: '', page: 1 })
    },

    vuexResetClassify ({ dispatch, state, rootState }, obj) {
      const query = { ...state.asideArr[rootState.activeIndex], page: 1, ...obj }
      const queryNoFilterCat2Cat3 = Object.assign(query, { cat2: 0, cat3: 0 })
      dispatch('vuexChangeHomeParames', queryNoFilterCat2Cat3)
    },

    vuexResetActiveIndex ({ rootState, dispatch }) {
      dispatch('vuexChangeActiveIndex', rootState.activeIndex)
    },

    vuexChangeHomeParames ({ dispatch, commit }, obj) {
      commit('vuexChangeHomeParames', obj)
      dispatch('vuexGetMatList')
    },

    async vuexGetMatList ({ dispatch, commit, state, rootGetters }) {
      const params = { ...state.home, size: 20 }

      commit('vuexChangeLoading', true, { root: true })

      let homeRes

      /** isWordOrExcelABTest */
      const isWordOrExcelABTest = rootGetters['abTest/isWordOrExcelABTest']

      if (state.listType === homeListType.download) {
        if (isWordOrExcelABTest) { /** 如果是abTest，则不区分2、3级分类 */
          Reflect.deleteProperty(params, Cat1)
          Reflect.deleteProperty(params, Cat2)
          Reflect.deleteProperty(params, Cat3)
        }
        homeRes = await dispatch('getDownloadList', params)
      }

      if (state.listType === homeListType.collect) {
        if (isWordOrExcelABTest) { /** 如果是abTest，则不区分2、3级分类 */
          Reflect.deleteProperty(params, Cat1)
          Reflect.deleteProperty(params, Cat2)
          Reflect.deleteProperty(params, Cat3)
        }
        homeRes = await dispatch('getFavoriteList', params)
      }

      if (state.listType === homeListType.search) {
        homeRes = await dispatch('getMatList', params)
      }

      commit('vuexChangeHomeRes', homeRes)
      commit('vuexChangeLoading', false, { root: true })
    },

    vuexGetUserCollectIdList ({ commit }) {
      return api.user.favoriteIds().then(res => {
        commit('vuexPushCollectIdList', res?.data?.list || [])
      })
    },

    vuexAddCollectId ({ state, commit }, id) {
      api.user.favoriteAdd({ data: { mat_id: id } }).then(res => {
        commit('vuexPushCollectIdList', id)
      })
    },

    getDownloadList ({ dispatch, commit }, params) {
      return api.user.downloads({ data: params }).then(res => {
        let list = res?.data?.download_infos || []
        const count = res?.data?.total || 0
        list = list.map((item) => (
          {
            id: item.mat_id,
            name: item.mat_name,
            himg: item.mat_cover_img
          }
        ))
        return { list, count }
      })
    },

    getFavoriteList ({ dispatch, commit }, params) {
      return api.user.favoriteList({ data: params }).then(res => {
        let list = res?.data?.fav_infos || []
        const count = res?.data?.total || 0
        list = list.map((item) => {
          return {
            id: item.mat_id,
            name: item.mat_name,
            himg: item.mat_cover_img
          }
        })
        return { list, count }
      })
    },

    getMatList ({ dispatch, commit }, params) {
      return api.material.matList({ data: params }).then(res => {
        const list = res?.data?.list || []
        const count = res?.data?.total_count || 0

        if (params.keyword) { // 搜索率低，提供上报排查， 获取数据接口是一样的
          report('searchpage', { actiontype: '1', word: params.keyword, amount: count, clickid: '', ext: extSearchpage.indexPage })
        }

        return { list, count }
      })
    },

    vuexRemoveCollectId ({ dispatch, commit, state }, id) {
      api.user.favoriteRemove({ data: { mat_id: id } }).then(res => {
        commit('removeCollectId', id)
      })
    }
  },
  getters: {

  }
}
